import React from 'react';
import { Helmet } from 'react-helmet';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Base from './Base';

function Contact() {
   return (
      <Base>
         <div className="dark:bg-dark-800 min-h-screen transition-colors duration-200">
            <Helmet>
              <title>Contact Us | Aman Medical Complex Gilgit</title>
              <meta name="description" content="Contact Aman Medical Complex Gilgit. Call us at +92-345 5558297 or email ehtishamglt@gmail.com. Located in Sakwar, Gilgit, Pakistan." />
              <meta name="keywords" content="contact hospital, hospital phone number, medical complex address, gilgit hospital contact" />
              <meta property="og:title" content="Contact Us | Aman Medical Complex Gilgit" />
              <meta property="og:description" content="Get in touch with us. We're here to help with all your healthcare needs." />
            </Helmet>

            {/* Page Title Section */}
            <section className="relative py-24 overflow-hidden bg-gradient-to-br from-primary-50 to-white dark:from-dark-800 dark:to-dark-900">
               <div className="absolute inset-0 z-0 opacity-5">
                  <div className="absolute top-10 left-10 w-72 h-72 bg-primary-500 rounded-full blur-3xl"></div>
                  <div className="absolute bottom-10 right-10 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
               </div>
               <div className="container mx-auto px-4 text-center relative z-10">
                  <span className="text-primary-500 font-bold uppercase tracking-[0.2em] text-xs md:text-sm inline-block mb-4">CONTACT US</span>
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-navy-500 dark:text-white mb-6 tracking-tight">Contact Us</h1>
                  <div className="flex items-center justify-center gap-2 text-gray-600 dark:text-gray-400 font-semibold text-sm">
                     <Link to="/" className="hover:text-primary-500 transition-colors">Home</Link>
                     <span>/</span>
                     <span className="text-primary-500">Contact</span>
                  </div>
               </div>
            </section>

            <section className="py-24 container mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-8">
               <div className="bg-white dark:bg-dark-800 p-10 rounded-3xl shadow-card text-center border border-gray-100 dark:border-dark-700 card-hover-lift">
                  <div className="w-16 h-16 bg-primary-50 dark:bg-primary-900/20 text-primary-500 rounded-full flex items-center justify-center text-2xl mx-auto mb-6">
                     <FaPhoneAlt />
                  </div>
                  <h3 className="text-xl font-black dark:text-white mb-2 text-navy-500">Call Center</h3>
                  <p className="text-gray-600 dark:text-gray-400 font-semibold">+92-345 5558297</p>
               </div>
               <div className="bg-white dark:bg-dark-800 p-10 rounded-3xl shadow-card text-center border border-gray-100 dark:border-dark-700 card-hover-lift">
                  <div className="w-16 h-16 bg-primary-50 dark:bg-primary-900/20 text-primary-500 rounded-full flex items-center justify-center text-2xl mx-auto mb-6">
                     <FaEnvelope />
                  </div>
                  <h3 className="text-xl font-black dark:text-white mb-2 text-navy-500">Email Address</h3>
                  <p className="text-gray-600 dark:text-gray-400 font-semibold">ehtishamglt@gmail.com</p>
               </div>
               <div className="bg-white dark:bg-dark-800 p-10 rounded-3xl shadow-card text-center border border-gray-100 dark:border-dark-700 card-hover-lift">
                  <div className="w-16 h-16 bg-primary-50 dark:bg-primary-900/20 text-primary-500 rounded-full flex items-center justify-center text-2xl mx-auto mb-6">
                     <FaMapMarkerAlt />
                  </div>
                  <h3 className="text-xl font-black dark:text-white mb-2 text-navy-500">Location</h3>
                  <p className="text-gray-600 dark:text-gray-400 font-semibold">Aman Medical Complex, Sakwar</p>
                  <p className="text-gray-600 dark:text-gray-400 font-semibold">Gilgit, Pakistan</p>
               </div>
            </section>

            <section className="py-24 bg-gray-50 dark:bg-dark-900/50">
               <div className="container mx-auto px-4">
                  <div className="max-w-4xl mx-auto bg-white dark:bg-dark-800 p-12 md:p-16 rounded-3xl shadow-strong border border-gray-100 dark:border-dark-700">
                     <h2 className="text-3xl font-black text-center dark:text-white mb-10 text-navy-500">Send Us A Message</h2>
                     <form className="grid grid-cols-1 md:grid-cols-2 gap-6" aria-label="Contact form">
                        <div>
                           <label htmlFor="contact-name" className="sr-only">Your Name</label>
                           <input 
                              id="contact-name"
                              type="text" 
                              placeholder="Your Name" 
                              className="w-full px-6 py-4 rounded-xl border border-gray-200 dark:border-dark-600 dark:bg-dark-700 dark:text-white outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-400 transition-all" 
                              aria-label="Your Name"
                           />
                        </div>
                        <div>
                           <label htmlFor="contact-email" className="sr-only">Your Email</label>
                           <input 
                              id="contact-email"
                              type="email" 
                              placeholder="Your Email" 
                              className="w-full px-6 py-4 rounded-xl border border-gray-200 dark:border-dark-600 dark:bg-dark-700 dark:text-white outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-400 transition-all" 
                              aria-label="Your Email"
                           />
                        </div>
                        <div className="md:col-span-2">
                           <label htmlFor="contact-subject" className="sr-only">Subject</label>
                           <input 
                              id="contact-subject"
                              type="text" 
                              placeholder="Subject" 
                              className="w-full px-6 py-4 rounded-xl border border-gray-200 dark:border-dark-600 dark:bg-dark-700 dark:text-white outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-400 transition-all" 
                              aria-label="Subject"
                           />
                        </div>
                        <div className="md:col-span-2">
                           <label htmlFor="contact-message" className="sr-only">Your Message</label>
                           <textarea 
                              id="contact-message"
                              rows="6" 
                              placeholder="Your Message" 
                              className="w-full px-6 py-4 rounded-xl border border-gray-200 dark:border-dark-600 dark:bg-dark-700 dark:text-white outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-400 transition-all"
                              aria-label="Your Message"
                           ></textarea>
                        </div>
                        <div className="md:col-span-2 text-center">
                           <button 
                              type="submit"
                              className="group bg-gradient-primary text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:scale-[1.02] active:scale-95 shadow-card-hover flex items-center justify-center gap-2 mx-auto focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2"
                              aria-label="Send contact message"
                           >
                              Send Message <FaArrowRight size={16} className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                           </button>
                        </div>
                     </form>
                  </div>
               </div>
            </section>
         </div>
      </Base>
   );
}

export default Contact;
